import axios from 'axios';
import { getAuthToken } from './api';

const reportsClient = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5200/api',
  timeout: 120000,
});

let elevatedToken = null;

export const setReportsElevatedToken = (token) => {
  elevatedToken = token || null;
};

const attachAuthHeader = (config) => {
  const next = { ...config, headers: { ...(config.headers || {}) } };
  const token = elevatedToken || getAuthToken();
  if (token) {
    next.headers.Authorization = `Bearer ${token}`;
  }
  return next;
};

reportsClient.interceptors.request.use(attachAuthHeader);

/** Keep in sync with backend reportCatalog.js */
export const REPORT_KEYS = [
  {
    key: 'vehicle-trip-detail',
    label: 'Vehicle trip detail',
    requirement: 'vehicle + date range',
    needsVehicle: true,
    optionalVehicle: false,
  },
  {
    key: 'fleet-summary',
    label: 'Total summary',
    requirement: 'date range',
    needsVehicle: false,
    optionalVehicle: false,
  },
  {
    key: 'fuel-consumption',
    label: 'Fuel-wise consumption',
    requirement: 'date range (vehicle optional)',
    needsVehicle: false,
    optionalVehicle: true,
  },
  {
    key: 'driver-summary',
    label: 'Driver trip summary',
    requirement: 'date range',
    needsVehicle: false,
    optionalVehicle: false,
  },
  {
    key: 'flagged-trips',
    label: 'Flagged trips',
    requirement: 'date range',
    needsVehicle: false,
    optionalVehicle: false,
  },
];

export const generateReport = (reportKey, filters) =>
  reportsClient.post('/reports/generate', { reportKey, filters }).then((res) => res.data);

export const getReportCatalog = () =>
  reportsClient.get('/reports/catalog').then((res) => res.data);

export default reportsClient;
